require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconTShirt.tsx
var IconTShirt_exports = {};
__export(IconTShirt_exports, {
  default: () => IconTShirt_default
});
module.exports = __toCommonJS(IconTShirt_exports);

// src/assets/monochrome/tShirt.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgTShirt = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.669 1.16315C7.07097 1.00435 7.52908 1.15371 7.7602 1.51894C8.35882 2.4649 9.2078 2.87798 9.99968 2.87798C10.7916 2.87798 11.6405 2.4649 12.2392 1.51894C12.4703 1.15371 12.9284 1.00435 13.3304 1.16315L19.3304 3.53352C19.7257 3.6897 19.9579 4.10119 19.8871 4.52033L19.2871 8.07588C19.2218 8.46293 18.9132 8.763 18.5245 8.81743L15.7415 9.20711L16.1985 17.9532C16.2113 18.1997 16.1224 18.4407 15.9525 18.6198C15.7825 18.7988 15.5465 18.9002 15.2997 18.9002H4.69968C4.45284 18.9002 4.21683 18.7988 4.04689 18.6198C3.87696 18.4407 3.78803 18.1997 3.80091 17.9532L4.25786 9.20711L1.47488 8.81743C1.08616 8.763 0.777542 8.46293 0.712229 8.07588L0.112229 4.52033C0.0414985 4.10119 0.273661 3.6897 0.668997 3.53352L6.669 1.16315ZM2.00845 4.93973L2.37743 7.12625L5.32448 7.53889C5.78675 7.60362 6.12281 8.01102 6.09846 8.47716L5.64793 17.1002H14.3514L13.9009 8.47716C13.8766 8.01102 14.2126 7.60362 14.6749 7.53889L17.6219 7.12625L17.9909 4.93973L13.3113 3.09099C12.4273 4.12476 11.2339 4.67798 9.99968 4.67798C8.76544 4.67798 7.5721 4.12476 6.68808 3.09099L2.00845 4.93973Z", fill: "#676F7E" }) });
var tShirt_default = SvgTShirt;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconTShirt.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconTShirt = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(tShirt_default, {}) });
};
IconTShirt.displayName = "IconTShirt";
var IconTShirt_default = IconTShirt;
